module.exports = __webpack_public_path__ + "img/aq.715536ff.svg";